import { useLocation } from "react-router-dom";
import { AtomEffect, atom, useRecoilState, useRecoilValue } from "recoil";

import {
  RegulatoryOrderingKey,
  RegulatoryOrderingValue,
} from "@/components/business/RegulatoryContainer/Regulatory.types";

import { RECOIL_KEYS } from "./recoilKeys";

import type { ProcessStatusCode } from "@/types/code.types";

export interface RegulatoryListSearchFilter {
  allInfo?: string;
  idInfo?: string;
  labelIdInfo?: string;
  labelNameInfo?: string;
  companyNameInfo?: string;
  allEditorInfo?: string;
  mcEditorNameInfo?: string;
  ftEditorNameInfo?: string;
}

export interface RegulatoryListFilter {
  search?: RegulatoryListSearchFilter;
  pageLimit: number;
  page: number;
  regulatoryListDataTotal: number;
  maxPage: number;
  classification: string[];
  status: ProcessStatusCode[];
  order: Partial<Record<RegulatoryOrderingKey, RegulatoryOrderingValue>>;
}

const handleSearchQuery =
  (): AtomEffect<RegulatoryListFilter> =>
  ({ setSelf, onSet }) => {
    const newSearchParams = new URLSearchParams();
    const location = useLocation();

    if (location.search) {
      const searchParams = new URLSearchParams(location.search);

      const { classification, status, search } = JSON.parse(
        Object.fromEntries(searchParams).filter,
      );

      setSelf({
        page: 1,
        maxPage: 1,
        pageLimit: 20,
        regulatoryListDataTotal: 0,
        classification: classification || [],
        status: status || [],
        order: {},
        search: search || {},
      });
    }
    onSet((newValue) => {
      if (window.location.pathname.includes("regulatory-list")) {
        newSearchParams.set("filter", JSON.stringify(newValue));
        window.history.pushState(
          "",
          "regulatory-list",
          `regulatory-list?${newSearchParams.toString()}`,
        );
      }
    });
  };

const regulatoryListFilterState = atom<RegulatoryListFilter>({
  key: RECOIL_KEYS.regulatoryListFilterState,
  default: {
    page: 1,
    maxPage: 1,
    pageLimit: 20,
    regulatoryListDataTotal: 0,
    classification: [],
    status: [],
    order: {},
    search: {},
  },
  effects: [handleSearchQuery()],
});

export const useRegulatoryListFilterState = () =>
  useRecoilState(regulatoryListFilterState);

export const useRegulatoryListFilterValue = () =>
  useRecoilValue(regulatoryListFilterState);
